

























































































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { InteractionModel } from '@/app/shared/models';
import { TypeIdEnum } from '@/app/shared/enums/notify/type-id.enum';
import {
  PaymentInfoModel,
  VForm,
  ContactBillingModel,
} from '@/app/shared/models';
import { CommunicationResponseModel } from '@/app/shared/models';
@Component({
  components: {},
})
export default class DialogCampaignResend extends Vue {
  @Ref() private form!: VForm;
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Boolean) readonly campaignTab?: boolean = false;
  @Prop(Function) readonly resendFn?: Function;
  @Prop(Object) readonly campaignMessage: CommunicationResponseModel = {
    CampaignId: '',
    CommunicationId: '',
    ContractId: '',
    Recipient: '',
    Tracking: '',
    TypeId: TypeIdEnum.Email,
    Scheduled: new Date(),
    TrackingDate: new Date(),
    Content: '',
    MessageId: '',
    Trackings: [],
    Id: '',
    Subject: '',
    Provider: '',
    MerchantKey: '',
    RecipientId: '',
    ReturnDescription: '',
    LinkExpirationDays: 30,
    LinkExpired: false,
    LinkValidity: new Date(),
  };

  private valueTab = '';
  private otherEmail = '';
  private EmailRequest = '';
  private emailsSelected: [] = [];
  private paymentInfo1: PaymentInfoModel = new PaymentInfoModel();
  private listPaymentInfo: PaymentInfoModel[] = [];
  private otherTelNumber = '';
  private listPhoneNumbers = [];
  private phoneSelecteds = [];

  private get refs() {
    return refsService;
  }

  private get rules() {
    return this.refs.static.rules;
  }

  private get contacts(): ContactBillingModel[] {
    return this.refs.modules.contract.customer.Contacts;
  }

  private async consultResendBankSlip() {
    this.EmailRequest = '';
    if (this.emailsSelected) {
      this.EmailRequest += this.emailsSelected;
    }

    if (this.otherEmail != '') {
      if (this.EmailRequest != '') {
        this.EmailRequest += ';';
      }
      this.EmailRequest += this.otherEmail;
    }
    if (this.EmailRequest == '') {
      this.$toast.error(this.$t('toasts.validate_resend_email_bankslip'));
      return;
    }

    await this.refs.modules.contract
      .resendBankSlip({
        contractId: this.refs.modules.contract.contract.Id,
        installmentId: this.refs.modules.contract.installment.Id,
        listEmails: this.EmailRequest,
      })
      .then(() => {
        this.$emit('close');
        this.clearFields();
        this.$toast(this.$t('toasts.resend_email_bankslip_successfully'));
      })
      .catch((err) => this.$toast.error('ERROR ? ', err));

    if (!this.refs.modules.ticket.consultResendBankSlip) {
      this.refs.modules.ticket.SET_CONSULT_RESEND_BANKSLIP(true);
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac19'),
          this.$t('action_desc.ad50') + ' - ' + this.valueTab
        )
      );
    }
  }
  private clearFields() {
    this.otherEmail = '';
    this.emailsSelected = [];
    this.valueTab = '';
    this.$emit('close');
  }

  private async resendEmailBankSlip() {
    if (this.campaignTab && this.resendFn) {
      const contacts: string[] = [];
      if (this.campaignMessage.TypeId == 'Email') {
        this.emailsSelected.forEach((contact: string) => {
          contact
            .replaceAll(',', ';')
            .split(';')
            .forEach((scontact) => {
              if (scontact) {
                contacts.push(scontact);
              }
            });
        });
        this.otherEmail
          .replaceAll(',', ';')
          .split(';')
          .forEach((contact) => {
            if (contact) {
              contacts.push(contact);
            }
          });
      } else {
        this.phoneSelecteds.forEach((phone: string) => {
          phone
            .replaceAll(',', ';')
            .split(';')
            .forEach((contact) => {
              if (contact) {
                contacts.push('55' + contact);
              }
            });
        });

        if (this.otherTelNumber.length == 11)
          contacts.push('55' + this.otherTelNumber);
      }

      return this.resendFn(contacts);
    }
    this.consultResendBankSlip();
  }

  private loadContactPhone(): string[] {
    const listPhoneNumbers: string[] = [];
    const listContacts = this.contacts;
    if (listContacts) {
      listContacts.forEach((contact) => {
        if (
          contact.Value &&
          !(
            this.refs.enums.ContactType[contact.Type] ==
            this.refs.enums.ContactType.Email.toString()
          )
        ) {
          listPhoneNumbers.push(contact.Value.toString());
        }
      });
    }
    // const contact: string = this.campaignMessage.Recipient.substring(0,2) == "55" ?
    // listPhoneNumbers.push(contact)

    return listPhoneNumbers;
  }
  private get loadPaymentInfo() {
    const listEmails: string[] = [];

    const listContacts = this.contacts;
    if (listContacts) {
      listContacts.forEach((contact) => {
        if (
          contact.Value &&
          this.refs.enums.ContactType[contact.Type] ==
            this.refs.enums.ContactType.Email.toString()
        ) {
          listEmails.push(contact.Value.toString());
        }
      });
    }

    // TODO: Remover
    //const installmentId = this.refs.modules.contract.installment.Id;
    // this.refs.modules.contract
    //   .loadPaymentInfoByInstallmentId({
    //     contractId: this.refs.modules.contract.contract.Id,
    //     installmentId,
    //   })
    //   .then(() => {
    //     this.refs.modules.contract.paymentInfo.forEach((paymentInfoAux) => {
    //       if (paymentInfoAux.Email) {
    //         listEmails.push(paymentInfoAux.Email);
    //       }
    //     });
    //   });
    return [...new Set(listEmails)];
  }
}
